import React from "react";
import { CardLayout } from "components/cardLayout";
import { companylogo } from "assets/images"
import "./EstimateBindingCard.scss"
import { getEstimatorDetails } from 'core/services/getEstimatorDetailsService'

export interface EstimateBindingCardProps {

}

export interface EstimateBindingCardState {
    companyDetails: any;
}

class EstimateBindingCard extends React.Component<EstimateBindingCardProps, EstimateBindingCardState> {
    private _isMounted: boolean = false;
    constructor(props: EstimateBindingCardProps) {
        super(props);
        this.state = {
            companyDetails: []
        };
    }

    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        let response = await getEstimatorDetails(CID)
        this.setState({ companyDetails: response[0] })
        console.log("CompDetail:" + JSON.stringify(this.state.companyDetails));
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CardLayout>
                <div className="firstText">
                    <h3>This estimate guarantees the total cost of the move based upon the quantities, conditions, and services defined by your binding estimate.<span> If you tender additional household goods or require additional services not identified in the binding estimate, the Carrier can either:</span></h3>
                </div>
                <div className="listContent">
                    <ol>
                        <li>
                            Negotiate a new binding estimate, accurately listing, in detail, the additional services required or requested.
                        </li>
                        <li>
                            Abide by your original binding estimate
                        </li>
                        <li>
                            Potentially Deny Service
                        </li>
                    </ol>
                </div>
                {/* <div className="firstText">
                    <h3><span>Note:</span> Impracticable Operations (inability to deliver with AMS assigned road
                        equipment) can result in additional charges of up to 15% of your original estimate to be due prior to delivery. Unforeseen circumstances at destination can lead to additional charges exceeding estimate to be billed 30 days post-delivery.</h3>
                </div> */}
                <div className="firstText">
                    <h3><span>Note:</span> <strong>Unforeseen Circumstances</strong> (such as elevators, stairs, or required parking permits) at the destination the mover can bill you for these additional expenses after 30 days after delivery. Charges for services required because of impracticable operations are due at delivery, but may not exceed 15 percent of all other charges due at delivery; any remaining charges will be billed to you with payment due in 30 days.</h3>
                </div>
                <div className="firstText marginText">
                    <h3><span>Notice: Carrier's Tariff, by this reference, are made a part of the Bill Of Lading and may be inspected at Carrier's facility, or, on request, carrier will furnish a copy of any Tariff provision containing Carriers rates, rules or charges governing the shipment.</span></h3>
                </div>
            </CardLayout>
        );
    }
}

export default EstimateBindingCard;